﻿$.fn.dxCtrlConfigEnvoiCadencement = function custom_dxCtrlConfigEnvoiCadencement(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlconfigenvoicadencement dx-ctrl");
        this.createInstance(new cdxCtrlConfigEnvoiCadencement(this, option));
    }
    return this;
}

window.cdxCtrlConfigEnvoiCadencement = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var table = null
    function mConstruit() {
        container.css("height", ((container.innerHeight() == 0) ? "" : container.innerHeight() + 'px'))
        container.empty();
        //plannification
        table = option.bddCtrl.getObjet(option.data).mGetTable()

        if (table.nom == "com_sms_envoi") {
            var $Tr = $("<tr/>").appendTo(container)
            var $Td = $("<td style='width:100%;padding:0 10px;' colspan='2'></td>").appendTo($Tr)
            $("<div style='margin:5px'/>").appendTo($Td).dxCtrlWarningForm({
                type: "warning",
                html: function () {
                    return "<div style='font-size:80%;'>" +
                        "L’envoi de SMS commerciaux est formellement interdit entre 20h00 et 08h00 les jours calendaires.<br/>" +
                        "Ces restrictions contractuelles avec les opérateurs sont édictées par l’AFMM et ne sont pas spécifiques à notre application.<br/>" +
                        "Le client s'engage à respecter ces obligations sous peine de fortes amendes et de suspension immédiate du compte.<br/>" +
                        "Le cadencement de vos envois a été configuré pour respecter cette législation.<br/>" +
                        "<br/>" +
                        "Si votre message n'est pas un message commercial (confirmation de commande, rendez vous, message d‘alerte, etc), vous pouvez modifier le cadencement à votre guise (<b>même s'il est conseillé de le garder en l'état</b>).<br/>" +
                        "Cette modification se fait sous votre entière responsabilité.<br/>" +
                        "</div>"
                }
            })
        }

        var change = false
        switch (table.nom) {
            case "com_email_envoi": case "com_sms_envoi":
                //date envoi
                //if (typeof option.showDateDebut == 'undefined' || option.showDateDebut) {
                if (option.date_envoi == null || option.date_envoi > parametre.dateNow) {
                    var $Tr = $("<tr/>").appendTo(container)
                    var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Date début envois</td>").appendTo($Tr)
                    var $Td = $("<td style='white-space:nowrap;width:1px;text-align:right;padding:0 10px 0 0;min-width:380px;'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlDateBox({
                        value: option.data.date_debut_envoi,
                        type: 'datetime',
                        placeholder: "Envoi immédiat",
                        onValueChanged: function (e) {
                            option.data.date_debut_envoi = e.value
                            option.bddCtrl.getObjet(option.data).mSaveChamp("date_debut_envoi",function () { mMajDateFinEnvoi() })
                            if (option.data.date_envoi != null) {
                                option.data.date_envoi = option.data.date_debut_envoi
                                option.bddCtrl.getObjet(option.data).mSaveChamp("date_envoi")
                            }
                            if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                        }
                    })
                }
                //Jour envoi
                var $Tr = $("<tr/>").appendTo(container)
                var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Jours envois</td>").appendTo($Tr)
                var $Td = $("<td style='white-space:nowrap;width:1px;text-align:left;padding:0 10px 0 0;min-width:380px;padding:10px 0;'/>").appendTo($Tr)
                if (table.nom == "com_sms_envoi" && (option.data.jour_envoi == null || option.data.jour_envoi.length == 0)) {
                    change = true
                    option.data.jour_envoi = "Lu|Ma|Me|Je|Ve"
                }
                $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlSelectJour({
                    label: "",
                    value: option.data.jour_envoi,
                    onValueChanged: function (e) {
                        option.data.jour_envoi = e.value
                        option.bddCtrl.getObjet(option.data).mSaveChamp("jour_envoi", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                }).find(".dx-ctrllstcheckbox").css("padding-top", "0").css("min-height", "0")
                //Jour férie
                var $Tr = $("<tr/>").appendTo(container)
                var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Hors jours fériés</td>").appendTo($Tr)
                var $Td = $("<td style='white-space:nowrap;width:1px;text-align:left;padding:5px 10px 5px 5px;min-width:380px;padding:10px 0;'/>").appendTo($Tr)
                if (table.nom == "com_sms_envoi" && (option.data.hors_jours_feries == null || option.data.hors_jours_feries == "0")) {
                    change = true
                    option.data.hors_jours_feries = "1"
                }
                $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlCheckBox({
                    text: "(Actuellement, " + ((option.data.hors_jours_feries == "1") ? "aucun envoi pendant les jours fériés)" : "envoi pendant les jours fériés)"),
                    value: (option.data.hors_jours_feries == "1"),
                    onValueChanged: function (e) {
                        option.data.hors_jours_feries = ((e.value) ? "1" : "0")
                        e.component.option("text", "(Actuellement, " + ((option.data.hors_jours_feries == "1") ? "aucun envoi pendant les jours fériés)" : "envoi pendant les jours fériés)"))
                        option.bddCtrl.getObjet(option.data).mSaveChamp("hors_jours_feries", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                })
                //horaire envoi
                var $Tr = $("<tr/>").appendTo(container)
                var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Horaire envois</td>").appendTo($Tr)
                var $Td = $("<td style='white-space:nowrap;width:1px;text-align:right;padding:0 10px 0 0;min-width:380px;padding:10px 0;'/>").appendTo($Tr)
                if (table.nom == "com_sms_envoi" && (option.data.horaire_envoi == null || option.data.horaire_envoi.length == 0)) {
                    change = true
                    option.data.horaire_envoi = "08:00|20:00"
                }
                $("<div/>").appendTo($Td).dxCtrlLstTimeBoxInterval({
                    value: option.data.horaire_envoi,
                    intervalMn: 30,
                    onValueChanged: function (e) {
                        option.data.horaire_envoi = e.value
                        option.bddCtrl.getObjet(option.data).mSaveChamp("horaire_envoi", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                })
                //cadencement email
                var $Tr = $("<tr/>").appendTo(container)
                var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Cadencement</td>").appendTo($Tr)
                var $TdCadence = $("<td style='white-space:nowrap;width:1px;text-align:right;padding:0 10px 0 0;min-width:380px;padding:10px 0;'/>").appendTo($Tr)
                var $TableCadencement = $("<table style='width:100%'/>").appendTo($TdCadence)
                var $Tr = $("<tr style='font-family:barlow condensed;'/>").appendTo($TableCadencement)
                var $Td = $("<td style='white-space:nowrap;width:1px;'>envoyer</td>").appendTo($Tr)
                var $Td = $("<td style='width:50%;min-width:120px;'></td>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlNumberBox({
                    min: 0,
                    value: option.data.tempo_envoi_nb_msg,
                    onValueChanged: function (e) {
                        option.data.tempo_envoi_nb_msg = e.value
                        option.bddCtrl.getObjet(option.data).mSaveChamp("tempo_envoi_nb_msg", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                })
                var $Td = $("<td style='width:1px;padding:0 5px;white-space:nowrap;'>" + ((table.nom == "com_sms_envoi") ? "sms" : "email(s)") + "<br/>tous les</td>").appendTo($Tr)
                var $Td = $("<td style='width:50%;min-width:120px;'></td>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlNumberBox({
                    min: 0,
                    value: option.data.tempo_envoi_sec,
                    onValueChanged: function (e) {
                        option.data.tempo_envoi_sec = e.value
                        option.bddCtrl.getObjet(option.data).mSaveChamp("tempo_envoi_sec", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                })
                var $Td = $("<td style='white-space:nowrap;width:1px;'>sec.</td>").appendTo($Tr)

                $("<div style='font-family:barlow condensed;font-style:italic;opacity:0.3;white-space:normal;text-align:center;'>Vos envois sont déjà cadencés pour un envoi optimal. Toutefois, pour augmenter votre délivrabilité, vous pouvez augmenter le cadencement si vous le désirez.</div>").appendTo($TdCadence)

                var $Tr = $("<tr style='font-weight:bold;'/>").appendTo(container)
                var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Date estimée<br/>de fin des envois</td>").appendTo($Tr)
                var $TdDateFinEnvoi = $("<td style='white-space:nowrap;width:1px;text-align:right;font-size:160%;line-height:0.7;padding:20px 10px 20px 0;min-width:380px;'></td>").appendTo($Tr)

                if (change) {
                    change = false
                    option.bddCtrl.getObjet(option.data).mSave(function (data) {
                        mMajDateFinEnvoi()
                    })
                } else { mMajDateFinEnvoi() }

                function mMajDateFinEnvoi() {
                    $TdDateFinEnvoi.text("Calcul...")
                    $TdDateFinEnvoi.addClass("blink")
                    option.bddCtrl.mAjaxCall({ command: "getdatefinenvoiestime", id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table, id_com: option.bddCtrl.getObjet(option.data).cle() }, function (data) {
                        if (data.date_fin_envoi.getFullYear() == 1901) { $TdDateFinEnvoi.text("---") }
                        else {
                            $TdDateFinEnvoi.html(data.date_fin_envoi.toDateIlya() + "<br/><span style='font-size:60%;'>" + data.date_fin_envoi.toFrenchDateTime() + "</span>")
                        }
                        $TdDateFinEnvoi.removeClass("blink")
                    })
                }
                break;
            default: break;
        }

        container.css("height", "")
    }

    this.element = function () { return container }

    mConstruit();
}